module.exports = __webpack_public_path__ + "static/icons/icon-clipboard--black-4047efbee653647570d195909f570fe9.svg";